import { useThemeContext } from '@/shared/providers/ThemeProvider';

/**
 * A hook to access the current tenant's theme configuration.
 *
 * This provides a centralized way to get theme properties like colors and icons,
 * ensuring that UI components can easily adapt to the current tenant's branding.
 *
 * @returns {object} The theme object from the tenant config, or an empty object if not available.
 *
 * @example
 * const theme = useTheme();
 * return <div className="bg-primary" />;
 */
export const useTheme = () => {
  const { branding, theme, loading } = useThemeContext();
  return { branding, theme, loading };
};